import React, { useState, useEffect, useRef } from 'react'
import { Input } from 'antd'
import './index.scss'

const PhotoComments = ({
  comments,
  themeColor,
  handleSaveComment,
  handleReportSA,
  location,
  currentPhoto
}) => {
  const [commentValue, setCommentValue] = useState<string>('')
  const [visibleHistoryComments, setVisibleHistoryComments] = useState(false)
  const [historyCommentsList, setHistoryCommentsList] = useState<string[]>([])
  const textAreaRef = useRef<any>(null)
  const commentDivWrapRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    setCommentValue('') // 切换图片时，清空输入框内容
  }, [currentPhoto])

  useEffect(() => {
    if (commentDivWrapRef.current) {
      commentDivWrapRef.current.scrollTo({
        top: commentDivWrapRef.current.scrollHeight
      })
    }
  }, [comments])

  const init = () => {
    setHistoryCommentsList(
      (JSON.parse(
        localStorage.getItem('historyCommentsList') as string
      ) as string[]) || []
    )
    // textAreaRef.current = document.getElementsByClassName(
    //   'textAreaBox'
    // )[0] as HTMLTextAreaElement
    // commentDivWrapRef.current = document.getElementsByClassName(
    //   'commentDivWrap'
    // )[0] as HTMLDivElement
  }
  const handleOnChange = (value) => {
    setCommentValue(value)
    let his = JSON.parse(localStorage.getItem('historyCommentsList') as string)
    if (!his || !value) return
    his = his
      .filter((item) => value.length <= item.length && item.startsWith(value))
      .splice(-6)
    setHistoryCommentsList(his)
    setVisibleHistoryComments(true)
  }

  const handleSend = (value) => {
    setCommentValue(value)
    const history =
      JSON.parse(localStorage.getItem('historyCommentsList') as string) || []
    if (history.includes(value)) {
      history.splice(history.indexOf(value), 1)
    }
    history.push(value)
    while (history.length > 200) {
      history.shift()
    }
    setHistoryCommentsList(history)
    localStorage.setItem('historyCommentsList', JSON.stringify(history))

    handleSaveComment([
      {
        type: 'text',
        content: value,
        atUserID: '' // 被 @ 的 userID
      }
    ]) // 请求接口，保存评论.(目前只有 text 类型 comment ,后续会有 @ 和 image)
    handleReportSA('sendComment', '', '', commentValue, location)
    setCommentValue('') // 发送评论发送完消息清空输入框
    setVisibleHistoryComments(false) // 隐藏历史输入内容
  }

  return (
    <div className={themeColor} onWheel={(e) => e.stopPropagation()}>
      <div className="commentDivWrap" ref={commentDivWrapRef}>
        {comments.length > 0 &&
          comments.map((comment, index) => {
            console.log(comment)
            return (
              <div
                key={comment.createdAt + index}
                className={`commentDiv ${
                  index === comments.length ? 'lastCommentItem' : ''
                }`}
              >
                <span
                  className="commentItemName"
                  title={comment.userInfo.nickname}
                >
                  {comment.userInfo.nickname}
                </span>
                <span>：</span>
                <div>
                  {comment.contents.map((item, index) => {
                    if (item.type === 'text')
                      return (
                        <span
                          className="commentText"
                          key={item.content + index}
                        >
                          {item.content}
                        </span>
                      )
                    if (item.type === 'at')
                      return (
                        <span
                          key={item.content + index}
                          className="commentAtItem"
                        >
                          {item.content}
                        </span>
                      )
                    if (item.type === 'image')
                      return (
                        <div
                          key={item.content + index}
                          style={{
                            width: '50px',
                            height: '90px',
                            position: 'relative'
                          }}
                        >
                          <img
                            style={{ width: '100%', height: '100%' }}
                            src={item.content}
                            alt={item.content}
                            onClick={() => {
                              handleReportSA(
                                'clickCommentPhoto',
                                '',
                                '',
                                '',
                                location
                              )
                            }}
                          />
                        </div>
                      )
                  })}
                </div>
              </div>
            )
          })}
      </div>

      <div className="inputSearch">
        {visibleHistoryComments && historyCommentsList.length > 0 && (
          <div
            className="historyCommentsList"
            style={{
              bottom: `${(() => {
                if (!textAreaRef.current) return '56px'
                // AntD 6: resizableTextArea 内部结构变化，直接获取 textarea DOM 元素高度
                const textarea =
                  (textAreaRef.current as any)?.resizableTextArea?.textArea ||
                  (textAreaRef.current as any)?.nativeElement ||
                  document.querySelector('.inputSearch textarea')
                const h = textarea
                  ? Number.parseInt(getComputedStyle(textarea).height)
                  : 40
                return h + 16 + 'px'
              })()}`
            }}
          >
            <div className="historyText">历史记录</div>
            {historyCommentsList.map((item, index) => {
              let pre = ''
              let suffix = item
              if (item.startsWith(commentValue)) {
                pre = item.substring(
                  item.indexOf(commentValue),
                  commentValue.length
                )
                suffix = item.substring(pre.length)
              }
              return (
                <div
                  className="commentItem"
                  key={item + index}
                  data-desc={item}
                  onClick={(e) => {
                    const val = (e.currentTarget as HTMLSpanElement).dataset[
                      'desc'
                    ] as string
                    setCommentValue(val)
                    handleReportSA('historyComment', '', '', val, location)
                    setVisibleHistoryComments(false) // 关闭 history comments list
                  }}
                >
                  <span style={{ color: '#6c9eff' }}>{pre}</span>
                  <span>{suffix}</span>
                </div>
              )
            })}
          </div>
        )}

        <div className="inputTextAreaBox">
          <Input.TextArea
            ref={textAreaRef}
            className="textAreaBox"
            value={commentValue}
            autoSize={{ minRows: 1, maxRows: 2 }}
            placeholder="添加评论"
            maxLength={200}
            onBlur={() => {
              // 输入框失去焦点，隐藏历史输入内容
              setTimeout(() => setVisibleHistoryComments(false), 300)
            }}
            onPressEnter={(e) => {
              e.preventDefault()
              if (!commentValue) return
              handleSend(commentValue)
            }}
            onFocus={() => {
              setVisibleHistoryComments(true)
              const his =
                (JSON.parse(
                  localStorage.getItem('historyCommentsList') as string
                ) as string[]) || []
              if (his.length > 0) {
                setHistoryCommentsList(his.splice(-6))
              }
              handleReportSA('comment', '', '', commentValue, location)
            }}
            onChange={(e) => {
              if (!e.target.value) {
                setVisibleHistoryComments(false)
              }
              handleOnChange(e.target.value)
            }}
          />
          <span
            className={`btnBase ${
              commentValue ? 'sendBtnActive' : 'sendBtnNormal'
            }`}
            onClick={() => {
              if (!commentValue) return
              handleSend(commentValue)
            }}
          >
            发送
          </span>
        </div>
      </div>
    </div>
  )
}

export default PhotoComments
